import * as React from 'react';
import Stack from "@mui/material/Stack";
import { PaDocument, PaFile } from "../../types/types";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import { VisibilityOutlined } from '@mui/icons-material';
import Popover from '@mui/material/Popover';
import { actionTypes, currPathValue, pdfMode, saveButtonMode, uiItemNames, wfRetteType } from '../../types/enums';
import CircularProgress from '@mui/material/CircularProgress';
import { CommentList } from '../DataTables/CommentList';
import Button from '@mui/material/Button';
import { fields, mapFieldToText } from "../../lang/constants";
import store from '../../configureStore';
import { setStateItem } from '../../actions/actionsBase';
import { getMetaItemValue, toLocaleUTCDateString } from '../../actions/folderViewActions';

interface ProarcDocumentProps {
    doc: PaDocument|null;
    docDataLoading: boolean;
    hasRequiredGroups: boolean;
    onLoadPdf: (fileRno:number, clientSide:boolean, mode: pdfMode, saveBtnMde: saveButtonMode) => void;
    onSetRevId: (docRno:number, revId:number) => void;
    onAddComment: (docRno:number,commLevel:number, commInput:string) => void;
    onStartInnmeldingsWf:  (doc:PaDocument, revRno:number, wfDesc:string, wfNotes:string, wfType: wfRetteType) => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  interface PaRevisionData {
    revCode: string;
    status: string;
    files: PaFile[];
  }
  
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export const ProarcDocument = (props:ProarcDocumentProps) => {
    const [value, setValue] = React.useState(1);
    const [revId, setRevId] = React.useState(props.doc===null ? "" : props.doc.CurrentRevision.RevisionCode);
    const [commInput, setCommInput] = React.useState<string>("");
    const [anchorElComm, setAnchorElComm] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElWf, setAnchorElWf] = React.useState<HTMLButtonElement | null>(null);
    const [wfDescInput, setWfDescInput] = React.useState<string>("");
    const [wfNotesInput, setWfNotesInput] = React.useState<string>("");

    //tab change
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {setValue(newValue);};

    //comment popover
    const openPopoverComm = (event: React.MouseEvent<HTMLButtonElement>) => {setAnchorElComm(event.currentTarget);};
    const handleCloseComm = () => {setAnchorElComm(null);};
    const openComm = Boolean(anchorElComm);
    const popoverIdComm = openComm ? 'simple-popover-comm' : undefined;
    const handleCommInputChange = (searchInput: string) => {setCommInput(searchInput);};
    
    //flyt popover
    const openWfPopover = (event: React.MouseEvent<HTMLButtonElement>) => {setAnchorElWf(event.currentTarget);};
    const handleWfClose = () => {setAnchorElWf(null);};
    const openWf = Boolean(anchorElWf);
    const popoverIdWf = openWf ? 'simple-popover-Wf' : undefined;
    const handleWfDescInputChange = (descInput: string) => {setWfDescInput(descInput);};
    const handleWfNotesInputChange = (notesInput: string) => {setWfNotesInput(notesInput);};

    
    const handleRevChange = (event: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
        setRevId(event.target.value);

        let revRno = props.doc!.Revisions.filter(rev => rev.RevisionCode === event.target.value).length > 0 ? props.doc!.Revisions.filter(rev => rev.RevisionCode === event.target.value)[0].RevRno 
                                        : props.doc!.CurrentRevision.RevisionCode === event.target.value ? props.doc!.CurrentRevisionRno : 0;
        props.onSetRevId(props.doc!.DocRno, revRno)
      };

    const revisions:PaRevisionData[] = props.doc===null ? [] : props.doc.Revisions.map(rev => {
            return  {
                        revCode: (rev.$ref !== undefined && rev.$ref !== null) ? props.doc!.CurrentRevision.RevisionCode : rev.RevisionCode,
                        status: (rev.$ref !== undefined && rev.$ref !== null) ? props.doc!.CurrentRevision.Status : rev.Status,
                        files: (rev.$ref !== undefined && rev.$ref !== null) ? props.doc!.CurrentRevision.Files : rev.Files,
                    }
    });

    let revCodes = revisions.length===0 ? <MenuItem value=""></MenuItem> : 
                    revisions.map((revision:PaRevisionData)=><MenuItem value={revision.revCode}>{revision.revCode} - {revision.status}</MenuItem>);
    
    let files = props.doc===null ? [] : 
            revisions.filter(x=>x.revCode === revId).length === 0 ? [] :
                revisions.filter(x=>x.revCode === revId)[0].files;        
     
    const filesTabTitle = `${mapFieldToText(fields.FILER)} (${files.length})`;
    const commTabTitle = `${mapFieldToText(fields.ACTIVITY_COMMENTS)} (${props.doc?.Comments === undefined ? "0": props.doc.WfComments.filter(x=>x.docId === "" || (x.docId===props.doc?.DocId && x.revisionRno === props.doc.SelectedRevPermisions?.RevRno)).length})`;
    
    if(props.doc===null )
    {
        return <></>
    }
    else
    {
        console.log("render document")
        return (
            <Stack sx={{ width: '100%' }}>
                {props.docDataLoading &&
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
                        <CircularProgress />
                    </Box>
                }
                {!props.docDataLoading &&
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label={mapFieldToText(fields.DETAILS_LOWCASE)} {...a11yProps(0)} sx={{flexGrow:1, fontWeight: 'bold'}}/>
                                <Tab label={filesTabTitle} {...a11yProps(1)} sx={{ flexGrow: 1, fontWeight: 'bold' }}/>
                                <Tab label={commTabTitle} {...a11yProps(2)} sx={{ flexGrow: 1, fontWeight: 'bold' }}/>
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Typography variant="h6"><b>{mapFieldToText(fields.STATUS)}:</b> {getMetaItemValue("STATUS",props.doc)}</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Typography variant="h6"><b>{mapFieldToText(fields.STATDATE)}:</b> {toLocaleUTCDateString(getMetaItemValue("STATDATE",props.doc),false)}</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Typography variant="h6"><b>{mapFieldToText(fields.DOK_KAT)}:</b>  {getMetaItemValue("DOK_KAT_DSC",props.doc)} ({getMetaItemValue("DOK_KAT",props.doc)})</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>                                
                                <Typography variant="h6"><b>{mapFieldToText(fields.FAG_KODE)}:</b> {getMetaItemValue("FAG_KODE_DSC",props.doc)} ({getMetaItemValue("FAG_KODE",props.doc)})</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Typography variant="h6"><b>{mapFieldToText(fields.DOK_TYPE)}:</b> {getMetaItemValue("DOK_TYPE",props.doc)}</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Typography variant="h6"><b>{mapFieldToText(fields.BAN_BANE)}:</b> {getMetaItemValue("BAN_BANE",props.doc)}</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Typography variant="h6"><b>{mapFieldToText(fields.BAN_BANESTREKNING)}:</b> {getMetaItemValue("BAN_BANESTREKNING",props.doc)}</Typography>
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Typography variant="h6"><b>{mapFieldToText(fields.BAN_DELSTREKNING)}:</b> {getMetaItemValue("BAN_DELSTREKNING",props.doc)}</Typography>
                            </Box>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', mb: 1, borderBottom: 1, borderColor: 'divider', }}>
                                <Box sx={{ width: '50%' }}>
                                    <TextField select
                                                variant="standard"
                                                defaultValue=""
                                                value = {revId}
                                                size="small"
                                                sx={{ mb: 1 }}
                                                onChange={(event)=>handleRevChange(event)}
                                    >
                                        {revCodes}
                                    </TextField>
                                </Box> 
                                <Box sx={{ width: '50%', display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                                    {props.doc.DbRno === 30 && 
                                        <Button variant="contained" 
                                            size="small" 
                                            onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                        openWfPopover(event);
                                                        // props.onStartInnmeldingsWf(props.doc!.DocRno,props.doc!.SelectedRevPermisions!.RevRno,"","");
                                                    }}
                                            disabled={
                                                    //does not have required groups
                                                    props.hasRequiredGroups === false
                                                    ||
                                                    //sa dokumet
                                                    props.doc.DocId.substring(0,3).toUpperCase()==="SA-"
                                                    ||
                                                    //finnes R revision already
                                                    props.doc.Revisions.concat([props.doc.CurrentRevision]).filter(x=>
                                                            x.RevisionCode ===
                                                            props.doc?.Revisions.concat([props.doc.CurrentRevision]).filter(x=>x.RevRno === props.doc?.SelectedRevPermisions?.RevRno)[0].RevisionCode + "R"
                                                        ).length>0
                                                    ||
                                                    //is R revision itself
                                                    props.doc?.Revisions.concat([props.doc.CurrentRevision]).filter(x=>x.RevRno === props.doc?.SelectedRevPermisions?.RevRno)[0].RevisionCode.endsWith("R")
                                                    ||
                                                    //not current
                                                    props.doc?.CurrentRevision.RevRno !== props.doc?.SelectedRevPermisions?.RevRno 
                                                    ||
                                                    //finnes som bygget revisjon
                                                    props.doc.Revisions.concat([props.doc.CurrentRevision]).filter(x=>
                                                            x.Status === "SOM BYGGET"
                                                        ).length>0
                                                    ||
                                                    //not godkjent
                                                    props.doc.Revisions.concat([props.doc.CurrentRevision]).filter(x=>
                                                        x.RevRno === props.doc?.SelectedRevPermisions?.RevRno                                                            
                                                    )[0].Status.toUpperCase()!=='GODKJENT'
                                                    ||
                                                    //not latest
                                                    props.doc.Revisions.concat([props.doc.CurrentRevision]).filter(x=>
                                                            x.RevRno > props.doc?.SelectedRevPermisions?.RevRno!
                                                        ).length>0

                                                }       
                                        >
                                            {mapFieldToText(fields.START_FLYT)}          
                                        </Button>}
                                </Box>
                            </Box>
                            <Table size="small" padding="none">
                                {files.filter(x=>(store.getState().appSettings.validFileTypes as string).includes(x.Extension)).map(file=>{

                                    // const canComment = false;
                                                            // props.doc!.SelectedRevPermisions!.FileUserAccesses.filter(x=>x.FileRno === file.FileRno).length>0 
                                                            // ? 
                                                            
                                                            // (
                                                            //     //props.doc?.SelectedRevPermisions?.FileUserAccesses.filter(x=>x.FileRno === file.FileRno)[0].CanCheckOutForCommenting
                                                            //     props.doc?.SelectedRevPermisions?.FileUserAccesses.filter(x=>x.FileRno === file.FileRno)[0].CanEdit
                                                            //     // && (
                                                            //     //         props.activity?.ActivityTemplate.WorkflowTemplateId.toString()===store.getState().appSettings.ertms.type.toString()
                                                            //     //         ||
                                                            //     //         props.activity?.ActivityTemplate.WorkflowTemplateId.toString()===store.getState().appSettings.retteflyt.type.toString()
                                                            //     //     )
                                                            // )

                                                            // :false;
                                    return  <TableRow>
                                        <TableCell>
                                            {file.Name}
                                        </TableCell>
                                        <TableCell>
                                            {(file.Size / (1024 * 1024)).toFixed(2) + ' MB'}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                // aria-describedby={popoverId}
                                                edge="end"
                                                aria-label="do search"
                                                onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                    // openPopover(event);
                                                    props.onLoadPdf(file.FileRno,true, pdfMode.view, saveButtonMode.save);
                                                    store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                    store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [...store.getState().uiItems.previousPath].concat([currPathValue.Document])));
                                                }}
                                                color="inherit"
                                                >
                                                <VisibilityOutlined />
                                            </IconButton>

                                            {/* {!canComment && <IconButton
                                                // aria-describedby={popoverId}
                                                edge="end"
                                                aria-label="do search"
                                                onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                    // openPopover(event);
                                                    props.onLoadPdf(file.FileRno,true,pdfMode.view, saveButtonMode.saveAsAttachment);
                                                    store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                    store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [currPathValue.Document]));
                                                }}
                                                color="inherit"
                                                >
                                                <VisibilityOutlined />
                                            </IconButton>   }
                                            {canComment && <IconButton
                                                // aria-describedby={popoverId}
                                                edge="end"
                                                aria-label="do search"
                                                onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                    // openPopover(event);
                                                    props.onLoadPdf(file.FileRno,true,pdfMode.edit, saveButtonMode.save);
                                                    store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                    store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [currPathValue.Document]));
                                                }}
                                                color="inherit"
                                                >
                                                <ChatBubbleOutline />
                                            </IconButton>   } */}
                                        </TableCell>
                                    </TableRow>
                                })}
                            </Table>
                            <Popover
                                id={popoverIdWf}
                                open={openWf}
                                anchorEl={anchorElWf}
                                marginThreshold={20}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                    }}
                                onClose={handleWfClose}
                                slotProps={{paper: {style: { width: '50%'}}}}
                            >
                                <Stack sx={{p:1}}>
                                        <Typography>{mapFieldToText(fields.SEND_REVISION)} {revId} {mapFieldToText(fields.ON_WF)}</Typography>
                                        <TextField
                                            sx={{p:1}}
                                            size="small" 
                                            id="outlined-multiline-flexible-wfDesc"
                                            label={mapFieldToText(fields.WORKFLOW_DESC)}
                                            multiline
                                            rows={3}
                                            value={wfDescInput} 
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleWfDescInputChange(event.target.value);}}
                                        />
                                        <TextField
                                            sx={{p:1}}
                                            size="small" 
                                            id="outlined-multiline-flexible-wfNotes"
                                            label={props.doc!.DocId.includes("-") ? mapFieldToText(fields.WORKFLOW_NOTES) : mapFieldToText(fields.WORKFLOW_NOTES_ERTMS)}
                                            multiline
                                            rows={3}
                                            value={wfNotesInput} 
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleWfNotesInputChange(event.target.value);}}
                                        />
                                        <Button variant="contained" 
                                                sx={{p:1}}
                                                size="small" 
                                                onClick={()=>{
                                                            props.onStartInnmeldingsWf(props.doc!,props.doc!.SelectedRevPermisions!.RevRno,wfDescInput,wfNotesInput, props.doc!.DocId.includes("-") ? wfRetteType.retteflyt : wfRetteType.ertms);
                                                            handleWfClose();
                                                            handleWfDescInputChange("");
                                                            handleWfNotesInputChange("");
                                                        }}>
                                            {mapFieldToText(fields.START_FLYT)}
                                        </Button>
                                </Stack>
                            </Popover>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                                <Button variant="contained" 
                                        size="small" 
                                        sx={{mb:1}}
                                        key={props.doc.DocRno}
                                        aria-describedby={popoverIdComm}
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                            openPopoverComm(event);
                                        }}
                                        disabled={
                                            props.doc.SelectedRevPermisions?.RevRno !== props.doc.CurrentRevision.RevRno
                                            &&
                                            props.doc.SelectedRevPermisions?.RevRno !== 
                                                (props.doc.Revisions[0].$ref !== undefined ?  props.doc.CurrentRevision.RevRno : props.doc.Revisions[0].RevRno )
                                        }
                                >
                                    {mapFieldToText(fields.ADD)} {mapFieldToText(fields.DOCUMENT_COMMENT)}
                                </Button>
                            </Box>
                            <CommentList comments={props.doc.WfComments.filter(x=>x.docId === "" || (x.docId===props.doc?.DocId && x.revisionRno === props.doc.SelectedRevPermisions?.RevRno))}
                                        LoadPdf={props.onLoadPdf}
                                        parent={currPathValue.Document}
                                        // openPopover={openPopover}
                                        />
                        </CustomTabPanel>
                        <Popover
                            id={popoverIdComm}
                            open={openComm}
                            anchorEl={anchorElComm}
                            marginThreshold={20}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                                }}
                                transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                                }}
                            onClose={handleCloseComm}
                            slotProps={{paper: {style: { width: '50%'}}}}
                        >
                            <Stack sx={{p:1}}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label="Add comment"
                                        multiline
                                        rows={3}
                                        value={commInput} 
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleCommInputChange(event.target.value);}}
                                    />
                                    <Button variant="contained" 
                                            size="small" 
                                            onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                        props.onAddComment(props.doc!.DocRno,0,commInput);
                                                        handleCloseComm();
                                                        handleCommInputChange("");
                                                    }}
                                            disabled={commInput===""}        
                                            >
                                        {mapFieldToText(fields.ADD)} {mapFieldToText(fields.ACTIVITY_DOCUMENT)} {mapFieldToText(fields.ACTIVITY_COMMENT)}
                                    </Button>
                                
                            </Stack>
                        </Popover>
                    </Box>  
                }
            </Stack>
        )
    }
}